/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface QuoteVisibilityHistory
 */
export interface QuoteVisibilityHistory {
  /**
   *
   * @type {string}
   * @memberof QuoteVisibilityHistory
   */
  quoteVisibilityHistoryId?: string;
  /**
   *
   * @type {string}
   * @memberof QuoteVisibilityHistory
   */
  quoteId?: string;
  /**
   *
   * @type {boolean}
   * @memberof QuoteVisibilityHistory
   */
  hiddenBefore?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof QuoteVisibilityHistory
   */
  hiddenAfter?: boolean;
  /**
   *
   * @type {string}
   * @memberof QuoteVisibilityHistory
   */
  reason?: string;
  /**
   *
   * @type {boolean}
   * @memberof QuoteVisibilityHistory
   */
  confirmedWithCarrier?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof QuoteVisibilityHistory
   */
  unsellableAfter?: boolean;
  /**
   *
   * @type {string}
   * @memberof QuoteVisibilityHistory
   */
  changedBy?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof QuoteVisibilityHistory
   */
  changedAt?: OffsetDateTime;
}

/**
 * Check if a given object implements the QuoteVisibilityHistory interface.
 */
export function instanceOfQuoteVisibilityHistory(
  value: object,
): value is QuoteVisibilityHistory {
  return true;
}

export function QuoteVisibilityHistoryFromJSON(
  json: any,
): QuoteVisibilityHistory {
  return QuoteVisibilityHistoryFromJSONTyped(json, false);
}

export function QuoteVisibilityHistoryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): QuoteVisibilityHistory {
  if (json == null) {
    return json;
  }
  return {
    quoteVisibilityHistoryId:
      json["quoteVisibilityHistoryId"] == null
        ? undefined
        : json["quoteVisibilityHistoryId"],
    quoteId: json["quoteId"] == null ? undefined : json["quoteId"],
    hiddenBefore:
      json["hiddenBefore"] == null ? undefined : json["hiddenBefore"],
    hiddenAfter: json["hiddenAfter"] == null ? undefined : json["hiddenAfter"],
    reason: json["reason"] == null ? undefined : json["reason"],
    confirmedWithCarrier:
      json["confirmedWithCarrier"] == null
        ? undefined
        : json["confirmedWithCarrier"],
    unsellableAfter:
      json["unsellableAfter"] == null ? undefined : json["unsellableAfter"],
    changedBy: json["changedBy"] == null ? undefined : json["changedBy"],
    changedAt: json["changedAt"] == null ? undefined : json["changedAt"],
  };
}

export function QuoteVisibilityHistoryToJSON(
  json: any,
): QuoteVisibilityHistory {
  return QuoteVisibilityHistoryToJSONTyped(json, false);
}

export function QuoteVisibilityHistoryToJSONTyped(
  value?: QuoteVisibilityHistory | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    quoteVisibilityHistoryId: value["quoteVisibilityHistoryId"],
    quoteId: value["quoteId"],
    hiddenBefore: value["hiddenBefore"],
    hiddenAfter: value["hiddenAfter"],
    reason: value["reason"],
    confirmedWithCarrier: value["confirmedWithCarrier"],
    unsellableAfter: value["unsellableAfter"],
    changedBy: value["changedBy"],
    changedAt: value["changedAt"],
  };
}
